import i18n from '../../../../i18n';
import {QueryOperator} from '../../types/Query';

const operators = [
  i18n.t('sessionSearch.queryList.operators.and'),
  i18n.t('sessionSearch.queryList.operators.or'),
  i18n.t('sessionSearch.queryList.operators.not'),
];

export const getOperators = () => operators;

export const getOperatorByType = (type: QueryOperator): string | undefined => {
  let operator = null;
  switch (type) {
    case 'AND':
      operator = operators[0];
      break;
    case 'OR':
      operator = operators[1];
      break;
    case 'NOT':
      operator = operators[2];
      break;
  }
  return operator;
};

export const getOperatorByValue = (value: string): QueryOperator => {
  const index = operators.indexOf(value);
  let operator: QueryOperator = 'AND';
  switch (index) {
    case 0:
      operator = 'AND';
      break;
    case 1:
      operator = 'OR';
      break;
    case 2:
      operator = 'NOT';
      break;
  }
  return operator;
};
